import { combineReducers } from 'redux';
import { accountReducer } from './account/reducer';
import { asynchronousStateReducer } from './asynchronousState/reducer';
import { EAuthActionType } from './auth/actions';
import { authReducer } from './auth/reducer';
import { blacklistReducer } from './blacklist/reducer';
import { compatibilityReportReducer } from './compatibilityReport/reducer';
import { configurationsReducer } from './configurations/reducer';
import { countersReducer } from './counters/reducer';
import { favoritesReducer } from './favorites/reducer';
import { Action } from './helpers';
import { initialRootState } from './initialRootState';
import { matchesReducer } from './matches/reducer';
import { memberchoicesReducer } from './memberchoices/reducer';
import { membersReducer } from './members/reducer';
import { messagesReducer } from './messages/reducer';
import { navigationReducer } from './navigation/reducer';
import { productsReducer } from './payment/reducer';
import { paymentHistoriesReducer } from './paymentHistories/reducer';
import { personalityReportReducer } from './personalityReport/reducer';
import { photoRequestsReducer } from './photoRequests/reducer';
import { photoRevealsReducer } from './photoReveals/reducer';
import { picturesReducer } from './pictures/reducer';
import { reflistsReducer } from './reflists/reducer';
import { specialOfferReducer } from './specialOffer/reducer';
import { IRootState } from './state';
import { subscriptionsReducer } from './subscriptions/reducer';
import { threadsReducer } from './threads/reducer';
import { visibilityUiReducer } from './visibilityUi/reducer';
import { visitsReducer } from './visits/reducer';

export const rootReducer = (state: IRootState | undefined, action: Action) => {
  if (state && action.type === EAuthActionType.RESET_STORE) {
    return coreReducer(
      {
        ...initialRootState,
        // This is needed to avoid that the application displays a splashcreen when a user logs out
        asynchronousState: {},
        configurations: state.configurations,
      },
      action
    );
  }

  return coreReducer(state, action);
};

const coreReducer = combineReducers({
  account: accountReducer,
  asynchronousState: asynchronousStateReducer,
  auth: authReducer,
  blacklist: blacklistReducer,
  compatibilityReport: compatibilityReportReducer,
  configurations: configurationsReducer,
  counters: countersReducer,
  favorites: favoritesReducer,
  matches: matchesReducer,
  memberchoices: memberchoicesReducer,
  members: membersReducer,
  messages: messagesReducer,
  navigation: navigationReducer,
  personalityReport: personalityReportReducer,
  photoRequests: photoRequestsReducer,
  photoReveals: photoRevealsReducer,
  pictures: picturesReducer,
  products: productsReducer,
  paymentHistories: paymentHistoriesReducer,
  reflists: reflistsReducer,
  specialOffer: specialOfferReducer,
  subscription: subscriptionsReducer,
  threads: threadsReducer,
  visits: visitsReducer,
  visibilityUi: visibilityUiReducer,
});
